// Das Audit-Log der Instanz, gelesen über die Management-API, seitenweise
// („Ältere laden" fragt mit `before_id` weiter).

import { useInfiniteQuery } from "@tanstack/react-query";
import { get } from "../../api/client";
import { keys } from "../../api/queries";
import type { InstanceAuditPage } from "../../api/types";
import { fmtDate } from "../../lib/format";
import { errorText } from "../../lib/labels";
import { Loading, Note } from "../../ui/badge";
import { Card } from "../../ui/card";
import type { TabProps } from "./tabs";

export function AuditTab({ tenant: t }: TabProps) {
  const q = useInfiniteQuery({
    queryKey: keys.tenantAudit(t.id),
    initialPageParam: null as number | null,
    queryFn: ({ pageParam }) => get<InstanceAuditPage>(`/tenants/${t.id}/audit${pageParam ? `?before_id=${pageParam}` : ""}`),
    getNextPageParam: (last) => last.next_before_id ?? undefined,
  });
  const entries = q.data?.pages.flatMap((p) => p.entries) ?? [];
  let body;
  if (q.isError) body = <div className="pf-card__body"><Note tone="error">{errorText(q.error)}</Note></div>;
  else if (q.isPending) body = <div className="pf-card__body"><Loading /></div>;
  else body = (
    <div className="pf-table-wrap">
      <table className="pf-table">
        <thead><tr><th>Zeit</th><th>Ereignis</th><th>Wer</th><th className="pf-hide-phone">Details</th></tr></thead>
        <tbody>
          {entries.length ? entries.map((e) => (
            <tr key={e.id}>
              <td className="pf-sub">{fmtDate(e.created_at)}</td>
              <td><code>{e.event}</code></td>
              <td>{e.actor_email ?? "—"}{e.platform_actor ? <div className="pf-sub">Plattform: {e.platform_actor}</div> : null}</td>
              <td className="pf-hide-phone"><span className="mono pf-sub">{JSON.stringify(e.details ?? {}).slice(0, 300)}</span></td>
            </tr>
          )) : <tr><td colSpan={4} className="pf-empty">Keine Einträge</td></tr>}
        </tbody>
      </table>
    </div>
  );
  return (
    <Card
      title="Audit-Log der Instanz"
      hint="Gelesen aus der Instanz (GET /api/platform/audit). Einträge aus einer Plattform-Sitzung tragen den Plattform-Admin."
      flush
      foot={!q.isError && q.hasNextPage ? <button type="button" className="pf-btn pf-btn--sm" disabled={q.isFetchingNextPage} onClick={() => void q.fetchNextPage()}>Ältere laden</button> : null}
    >{body}</Card>
  );
}
